import type { MediaWrapperContainerTypeEnum } from '@/utils/aspectRatioUtils';

import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';

import type { CardProps } from '../../types';
import { CardContent } from '../CardContent';

import * as Gs from '../../Card.styles';
import * as S from './CountDownType.styles';

export const CountDownType = (_props: CardProps) => {
  const {
    backgroundAlignment,
    backgroundColor,
    cardGroupType,
    contentAlignment,
    media,
    mediaAnimationEffect,
    mediaWrapperType,
    preload,
    sizes,
    textAlignment,
    visibleInDesktop,
    visibleInMobile,
  } = _props;

  const hasBackgroundImage = !!media?.video?.url || !!media?.image?.url;

  return (
    <S.Wrapper
      $hasBackgroundImage={hasBackgroundImage}
      contentAlignment={contentAlignment}
      data-test-id='CardCountDownWrapper'
      mediaAnimationEffect={
        mediaAnimationEffect === 'zoomOnHover' ? mediaAnimationEffect : null
      }
      visibleInDesktop={visibleInDesktop}
      visibleInMobile={visibleInMobile}
    >
      {backgroundColor?.value && (
        <Gs.Background $backgroundColor={backgroundColor?.value} />
      )}
      <S.MediaBox
        $backgroundAlignment={backgroundAlignment}
        data-test-id='CardCountMedia'
      >
        <MediaWrapper
          {...(media as ContentfulImageWithFocalPointFragment)}
          cardGroupType={cardGroupType as MediaWrapperContainerTypeEnum}
          mediaWrapperType={mediaWrapperType}
          preload={preload}
          sizes={sizes}
        />
      </S.MediaBox>

      <S.Content textAlignment={textAlignment}>
        <CardContent {..._props} />
      </S.Content>
    </S.Wrapper>
  );
};
